import KitFadeView from '@omni/kit/components/KitFadeView';
import KitText from '@omni/kit/components/KitText';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

export default function LiveIndicator({
  isVisible = true,
  style,
}: {
  isVisible?: boolean;
  style?: StyleProp<ViewStyle>;
}): ReactElement {
  const { t } = useTranslation(['common']);

  return (
    <KitFadeView show={isVisible} style={[styles.container, style]}>
      <View style={styles.liveDot} />
      <KitText white fontSize={14} bold style={styles.liveText}>
        {t('common:live')}
      </KitText>
    </KitFadeView>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 20,
  },
  liveDot: {
    backgroundColor: Colors.R500,
    borderRadius: BorderRadius.full,
    height: 6,
    width: 6,
  },
  liveText: {
    marginLeft: Spacing.s,
  },
});
